import React, { useState, useEffect } from "react";
import useFetchCsrfToken from "../../components/0. Utilidades/useFetchCsrfToken";

function WhatsappGroupUpdater() {
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [inputText, setInputText] = useState("");
  const [status, setStatus] = useState(null);
  const csrfToken = useFetchCsrfToken();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_API}api/perfiles/whatsapp_grupos/`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then(setGroups);
  }, []);

  const extractNumbers = () => {
    const match = inputText.match(/\+56\s9\s\d{4}\s\d{4}/g) || [];
    return [...new Set(match.map(n => n.replace(/\s+/g, "")))]; // e.g. "+56994739508"
  };

  const handleSubmit = async () => {
  const celulares = extractNumbers();
  if (!selectedGroup || celulares.length === 0) return;

  const groupId = selectedGroup;
  const response = await fetch(
    `${process.env.REACT_APP_BASE_API}api/perfiles/whatsapp_grupos/${groupId}/actualizar_maestras_por_celular/`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
      },
      credentials: "include",
      body: JSON.stringify({ celulares }),
    }
  );

  const result = await response.json();
  setStatus(result);

  // ✅ Clear textarea after success
  if (response.ok) {
    setInputText("");
  }
};


  return (
    <div className="capsule d-flex flex-column">
      <h2 className="text-xl font-bold mb-2">Actualizar Grupo de WhatsApp</h2>

      <select
        className="w-full border rounded p-2 mb-2"
        onChange={(e) => setSelectedGroup(e.target.value)}
        defaultValue=""
      >
        <option value="" disabled>Selecciona un grupo</option>
        {groups.map((g) => (
          <option key={g.id} value={g.id}>{g.nombre}</option>
        ))}
      </select>

      <textarea
        className="w-full p-2 border rounded mb-2"
        rows="6"
        placeholder="Pega aquí el contenido del span..."
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
      />

      <button
        className="btn-outline-primary px-4 py-2 rounded hover:bg-green-700"
        onClick={handleSubmit}
      >
        Actualizar Grupo
      </button>

      {status && (
  <div className="mt-4 text-sm text-gray-800">
    <p><strong>Total números detectados:</strong> {status.total}</p>
    <p><strong>Maestras agregadas:</strong> {status.added}</p>

    {status.not_found?.length > 0 && (
      <div className="mt-2">
        <p className="font-semibold">No se encontraron estas maestras:</p>
        <ul className="list-disc pl-6">
          {status.not_found.map((n, i) => (
            <li key={i}>{n}</li>
          ))}
        </ul>
      </div>
    )}
  </div>
)}

    </div>
  );
}

export default WhatsappGroupUpdater;
